import { getUploadsStore } from '../modules/uploadsStore';

export const UploadsStore = getUploadsStore();
